import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Badge, Table } from 'react-bootstrap';
import { calculateNetCaseWeight, calculateGrossCaseWeight, calculateVolumeCubicFeet } from '../utils/commonUtils';

function StockItemInfo({ stockItem }) {
    const netCaseWeight = calculateNetCaseWeight(
        stockItem.item_size,
        stockItem.item_size_units,
        stockItem.case_pack
    );

    const grossCaseWeight = calculateGrossCaseWeight(
        stockItem.item_size,
        stockItem.item_size_units,
        stockItem.case_pack,
        stockItem.package_weight
    );

    const getCountryFlag = (countryCode) => {
        if (!countryCode || countryCode.length !== 2) return '';
        const OFFSET = 127397;
        const first = countryCode.charCodeAt(0) + OFFSET;
        const second = countryCode.charCodeAt(1) + OFFSET;
        return String.fromCodePoint(first, second);
    };

    return (
        <Card className="shadow-sm position-relative" style={{ width: '450px', height: '450px' }}>
            <div className="position-absolute w-100 h-100">
            <span>{stockItem.description}</span>
                {stockItem.image ? (
                    <img 
                        src={stockItem.image} 
                        alt={stockItem.description} 
                        className="w-100 h-100"
                        style={{ objectFit: 'cover' }}
                    />
                ) : (
                    <div className="w-100 h-100 bg-light d-flex justify-content-center align-items-center">
                        <i className="bi bi-image" style={{ fontSize: '50px', color: 'darkgray' }}></i>
                    </div>
                )}
            </div>
            <Table className="position-absolute h-100" style={{ 
                width: '170px',
                marginLeft: '240px',
                marginTop: '21px',
                backgroundColor: 'transparent',
            }} hover>
                <tbody style={{ backgroundColor: 'transparent' }}>
                    <tr style={{ backgroundColor: 'transparent' }}>
                        <td style={{
                            backgroundColor: 'rgba(var(--bs-body-bg-rgb), 0.9)',
                            textAlign: 'left'
                        }}>
                        <div style={{ marginBottom: '6px' }}><strong>SKU:</strong> {stockItem.sku || 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}><strong>Manufacturer:</strong> {stockItem.manufacturer_name || 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}><strong>GTIN:</strong> {stockItem.gtin || 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}><strong>UPC:</strong> {stockItem.upc || 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}>
                            <strong>Country:</strong> {stockItem.country_of_origin ? (
                                <>{getCountryFlag(stockItem.country_of_origin)} {stockItem.country_of_origin}</>
                            ) : 'N/A'}
                        </div>
                        <div style={{ marginBottom: '6px' }}><strong>Item Size:</strong> {stockItem.item_size ? `${stockItem.item_size} ${stockItem.item_size_units}` : 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}><strong>Case Pack:</strong> {stockItem.case_pack}</div>
                        <div style={{ marginBottom: '6px' }}><strong>Net Case W:</strong> {netCaseWeight} lbs</div>
                        <div style={{ marginBottom: '6px' }}><strong>Gross Case W:</strong> {grossCaseWeight} lbs</div>
                        <div style={{ marginBottom: '6px' }}>
                            <i className="bi bi-rulers"></i>{' '}
                            {stockItem.dimensions_l && stockItem.dimensions_w && stockItem.dimensions_h ? (
                                `${stockItem.dimensions_l}" × ${stockItem.dimensions_w}" × ${stockItem.dimensions_h}"`
                            ) : 'N/A'}
                        </div>
                        <div style={{ marginBottom: '6px' }}><strong>Package W:</strong> {stockItem.package_weight || 'N/A'} lbs</div>
                        <div style={{ marginBottom: '6px' }}><strong>TI:</strong> {stockItem.ti || 'N/A'} <strong>HI:</strong> {stockItem.hi || 'N/A'}</div>
                        <div style={{ marginBottom: '6px' }}><strong>Volume:</strong> {calculateVolumeCubicFeet(stockItem.dimensions_l, stockItem.dimensions_w, stockItem.dimensions_h) || 'N/A'} cubic ft</div>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Card>
    );
}

export default StockItemInfo;